<template>
  <HeadlessTransitionRoot
    appear
    :show="setDataDialogStore.isOpen"
    as="template"
  >
    <HeadlessDialog
      as="div"
      class="relative z-50"
      @close="setDataDialogStore.close()"
    >
      <HeadlessTransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-25">
          <MouseFollower :hide-when-over-el="dialogPanelEl" />
        </div>
      </HeadlessTransitionChild>

      <div class="fixed bottom-0 left-0 top-0 w-screen overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-5 text-center">
          <HeadlessTransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <HeadlessDialogPanel class="w-full max-w-4xl rounded-2xl shadow-xl transition-all">
              <form
                ref="dialogPanelEl"
                class="flex rounded-2xl bg-whitegray p-4 flex-col sm:flex-row sm:p-10"
                @submit.prevent="onSubmit"
              >

                  <div class="flex-1 flex-grow flex items-center justify-center mb-5 sm:mb-0 sm:order-2 sm:justify-end">
                      <img src="~/assets/icon/icon-gift.png" alt="" class="max-h-32 sm:max-h-none" />
                  </div>

                  <div class="flex flex-col gap-4 flex-1 flex-grow">
                      <h1 class="mb-2 w-full text-center font-medium text-2xl ">Рады снова видеть вас!</h1>

                      <h3 class="mb-2">Заполните недостающую информацию, и мы начислим бонусные баллы на любимые роллы</h3>

                      <InputPhone
                          v-if="!user?.phone"
                          name="phone"
                          label="Телефон"
                      />
                      <div class="flex w-full gap-3" v-if="!user?.email">
                          <div class="w-full">
                              <InputText
                                  name="email"
                                  label="Электронная почта"
                              />
                          </div>

                          <div class="rounded-xl bg-white text-base flex flex-col p-2 px-4 shadow-main">
                              <img src="~/assets/icon/icon-coin.png" alt="" class="m-auto" />
                              <div>+&nbsp;300</div>
                          </div>
                      </div>

                      <div class="flex w-full gap-3">
                          <div class="w-full">
                              <!--<InputDatepicker
                                  name="birthday"
                                  label="Дата рождения"
                                  :locked="!!user?.birthday"
                              />-->
                              <InputDateMask
                                  v-model="birthday"
                                  name="birthday"
                                  label="Дата рождения"
                                  :locked="!!user?.birthday"
                              />
                          </div>

                          <div class="rounded-xl bg-white text-base flex flex-col p-2 px-4 shadow-main">
                              <img src="~/assets/icon/icon-coin.png" alt="" class="m-auto" />
                              <div>+&nbsp;300</div>
                          </div>
                      </div>

                      <SimpleButton
                          class="mt-4 w-full px-4 py-4 uppercase"
                          type="submit"
                          :disabled="isPending"
                      >
                          Сохранить
                      </SimpleButton>
                  </div>

              </form>
            </HeadlessDialogPanel>
          </HeadlessTransitionChild>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import * as yup from 'yup'
import { useSetDataDialog } from '~/store/setDataDialog'
import { DateTime } from 'luxon'

const setDataDialogStore = useSetDataDialog()

const dialogPanelEl = ref<HTMLElement>()

const { handleSubmit, resetForm } = useForm({
  validationSchema: yup.object({
    phone: yup.string().required('Введите телефон').length(11, 'Некорректный номер телефона').label('Телефон'),
    email: yup.string().email('Некорректный адрес').label('Электронная почта'),
    birthday: yup.date().label('Дата рождения'),
  }),
  keepValuesOnUnmount: true,
})

const birthday = ref()

const { data: user } = useUser((v) =>  {
    if(v.birthday) {
            birthday.value = new Date(v.birthday).toLocaleDateString("ru-RU")
        }

        return {
            phone: v.phone,
            email: v.email,
            birthday: v.birthday,
        }
    }
)

watch(
  [user],
  () => {
    const phone = user.value?.phone || undefined
    const email = user.value?.email || undefined
    const birthday = user.value?.birthday || undefined

    if (phone || email) {
      resetForm({
        values: {
          phone,
          email,
          birthday
        },
      })
    }
  },
  {
    immediate: true,
  }
)

const { mutateAsync, isPending } = useSetUser()

const onSubmit = handleSubmit((vals: any) => {
    vals.birthday = ""
    if(birthday.value?.length > 0) {
        vals.birthday = DateTime.fromFormat(birthday.value, "dd.MM.yyyy").toJSDate()
    }

  mutateAsync({
    phone: vals.phone,
    email: vals.email,
    birthday: vals.birthday,
  }).then(setDataDialogStore.close)
})
</script>
